module.exports = __webpack_public_path__ + "public/images/singing.dbdcc4c133e41865d93392abde905494.jpg";